<template>
    <div class="texto-container">
        <div class="numeracao">
            <div v-for="linha in linhas" :key="linha" class="hljs-comment">
                {{ linha }}
            </div>
        </div>
        <div>
            <pre class="texto"><code v-html="textoDestacado"></code></pre>
        </div>
    </div>
</template>

<script>
import hljs from "highlight.js";
import yaml from "highlight.js/lib/languages/yaml";
import "highlight.js/styles/default.css";

hljs.registerLanguage("yaml", yaml);

export default {
    name: "codigo",
    props: {
        texto: {
            required: true,
            type: String,
        },
    },
    computed: {
        textoDestacado() {
            return hljs.highlight(this.texto, {
                language: "yaml",
            }).value;
            // return this.texto;
        },
        linhas() {
            return this.texto.split("\n").length;
        },
    },
};
</script>

<style scoped>
.numeracao {
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    border-right: 1px dashed rgb(196, 204, 204);
    user-select: none;
    height: max-content;
    min-width: 50px;
}

.numeracao div {
    text-align: right;
    padding-right: 5px;
}

.texto-container {
    padding: 10px;
    border: 1px solid rgb(196, 204, 204);
    height: 500px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: scroll;
    display: flex;
    flex-direction: row;
}

.texto code {
    background-color: transparent;
    margin: 0;
    white-space: pre;
}
</style>
